export enum ForgetPasswordFomNames {
	email = 'email',
	currentPassword = 'currentPassword',
	newPassword = 'newPassword',
	confirmNewPassword = 'confirmNewPassword',
}
